import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Modal, ModalBody } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { isEmpty } from "lodash";
import { ModalHeader } from "react-bootstrap";
import { Icon } from "@iconify/react/dist/iconify.js";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import EmptyData from "../../../components/EmptyData";
import SearchTable from "../../../components/SearchTable";
import ErrorMessage from "../../../components/ErrorMessage";
import DataExporter from "../../../components/DataExporter";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { geoAdminContext } from "../../../context/AdminContext/GeoAdminContext/GeoAdminContext";
import { createGeoValidation } from "../../../utils/validation/validation";
import { convertDate } from "../../../utils";
import { exporterData } from "../../../utils/enum";

const GeoAdmin = () => {
  const {
    setCities,
    geo,
    setGeo,
    id,
    isShowModal,
    handleHideModal,
    handleGetGeo,
    handleCreateGeo,
    handleEditGeo,
  } = useContext(geoAdminContext);

  useEffect(() => {
    handleGetGeo();
  }, []);

  // Validation
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(createGeoValidation),
  });

  return (
    <>
      <SiteTitle title="شهر ها" />

      <TableContent setValue={setValue} reset={reset} />

      <Modal
        show={isShowModal}
        onHide={() => handleHideModal()}
        className="modal-dialog-centered"
        size="md"
      >
        <ModalHeader closeButton>
          <span className="fs-5 fw-bold">
            {id ? "ویرایش شهر" : "افزودن شهر جدید"}
          </span>
        </ModalHeader>
        <ModalBody>
          <form
            autoComplete="off"
            onSubmit={handleSubmit(id ? handleEditGeo : handleCreateGeo)}
          >
            <div className="mb-10">
              <div>
                <label
                  htmlFor="name"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  نام
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="name"
                  placeholder="نام شهر را وارد نمایید"
                  {...register("name")}
                />
              </div>

              <ErrorMessage message={errors.name?.message} />
            </div>

            <div className="text-end mt-3">
              <button
                type="submit"
                className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
              >
                {id ? "ویرایش" : "افزودن"} شهر
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <Modal
        show={!isEmpty(geo)}
        onHide={() => {
          setCities([]);
          setGeo({});
        }}
        className="modal-dialog-centered"
        size="xl"
      >
        <ModalHeader closeButton>
          <span className="fs-5 fw-bold">مدیریت شهر های {geo.name}</span>
        </ModalHeader>
        <ModalBody>
          <TableContent setValue={setValue} reset={reset} isCity />
        </ModalBody>
      </Modal>
    </>
  );
};

export default GeoAdmin;

const TableContent = ({ reset, setValue, isCity }) => {
  const { provinces, cities, handleShowModal, handleGetGeo, handleDeleteGeo } =
    useContext(geoAdminContext);

  const items = isCity ? cities : provinces;

  return (
    <div className="card h-100 p-0 radius-12">
      <SearchTable
        firstItem="&nbsp;"
        endItem={
          <div className="d-flex justify-content-between align-items-center gap-2">
            {!isEmpty(items) && (
              <DataExporter
                headers={exporterData.geo.headers}
                keys={exporterData.geo.keys}
                data={items}
                fileName={exporterData.geo.fileName}
              />
            )}
            <button
              className="btn btn-primary text-sm btn-sm radius-8 d-flex align-items-center gap-2"
              onClick={() => {
                handleShowModal();
                reset();
              }}
            >
              <Icon icon="ic:baseline-plus" className="text-xl" />
              افزودن شهر
            </button>
          </div>
        }
      />
      <div className="card-body p-24">
        {isEmpty(items) ? (
          <EmptyData />
        ) : (
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">نام</th>
                  <th scope="col">تاریخ ایجاد</th>
                  <th scope="col">تاریخ آخرین ویرایش</th>
                  <th scope="col" />
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>{convertDate(item.createdAt, "YYYY/MM/DD - HH:mm")}</td>
                    <td>{convertDate(item.updatedAt, "YYYY/MM/DD - HH:mm")}</td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="hover-bg-transparent"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <Icon
                            icon="ph:dots-three-outline-fill"
                            className="menu-icon"
                          />
                        </button>
                        <ul className="dropdown-menu list">
                          {!isCity && (
                            <li
                              onClick={() => handleGetGeo(item)}
                              className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 cursor-pointer"
                            >
                              شهر ها
                            </li>
                          )}
                          <li
                            onClick={() => {
                              reset();
                              handleShowModal(item, setValue);
                            }}
                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 cursor-pointer"
                          >
                            ویرایش
                          </li>

                          <li className="dropdown-divider" />

                          <li
                            onClick={() =>
                              areYouSureMessage(
                                () => handleDeleteGeo(item._id),
                                `آیا از حذف شهر ${item.name} مطمئنید؟`
                              )
                            }
                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 cursor-pointer text-danger"
                          >
                            حذف
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
